import { OrderType, Product, RequestTrackingType } from "shared/cubiq-model-multi-asset";

export class ProductRenderer {
  static render(
    product: Product,
    requestTrackingType: RequestTrackingType,
    orderType: OrderType,
  ): any {
    switch (product) {
      case Product.SPT:
        return "Spot";
      case Product.FWD:
        if (this.isSpotTrackedFwd(requestTrackingType, orderType)) {
          return "Fwd (Spot)";
        } else {
          return "Fwd";
        }
      case Product.NDF:
        if (this.isSpotTrackedFwd(requestTrackingType, orderType)) {
          return "NDF (Spot)";
        } else {
          return "NDF";
        }
      case Product.SWP:
        return "Swap";
      case Product.SSP:
        return "SSP";
    }
  }

  static isSpotTrackedFwd(requestTrackingType: RequestTrackingType, orderType: OrderType) {
    return (
      RequestTrackingType.OUTRIGHT_RATE != requestTrackingType &&
      OrderType.ALGO != orderType &&
      OrderType.BENCHMARK != orderType
    );
  }
}
